module.exports = __webpack_public_path__ + "img/ahmad.1f068af4.png";